// extracted by mini-css-extract-plugin
module.exports = {"cardCrm":"CtiList_cardCrm_1ot-I","cardBodyWrap":"CtiList_cardBodyWrap_3kHnh","logoWrap":"CtiList_logoWrap_1AHCH","logo":"CtiList_logo_2uzxm"};